import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=709ee060&scoped=true"
import script from "./Visits.vue?vue&type=script&lang=js"
export * from "./Visits.vue?vue&type=script&lang=js"
import style0 from "./Visits.vue?vue&type=style&index=0&id=709ee060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ee060",
  null
  
)

export default component.exports